import { Box, BoxProps } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';

export const StyledAreaBox = styled(Box)<BoxProps & { theme?: Theme }>(({ theme }) => ({
  maxWidth: '580px',
  padding: '16px',
  borderRadius: '12px',
  border: 'none',
  // Use CSS variable for theme-aware background
  backgroundColor: 'var(--sk-surface-default)',
  // Ensure text inside is visible
  color: 'var(--sk-text-primary)',
  '& .MuiTypography-root': {
    color: 'var(--sk-text-primary)',
  },
  '& .MuiTypography-colorTextSecondary, & .MuiTypography-caption': {
    color: 'var(--sk-text-secondary)',
  },
}));

export const StyledInfoBox = styled(Box)<BoxProps & { theme?: Theme }>(({ theme }) => ({
  padding: '6px 16px',
  borderRadius: '12px',
  border: '1px solid var(--sk-cyan-500)',
  color: 'var(--sk-cyan-600)',
  backgroundColor: 'rgba(0, 200, 224, 0.1)',
}));
